import { Component, OnInit } from '@angular/core';
import { RotinaCliente } from '../../comum/modelos/rotina-cliente';
import { RotinaService } from '../rotina.service';
import { ComumService } from '../../comum/comum.service';
import { CriterioAvaliacao } from '../../comum/modelos/criterio-avaliacao';
import { CriterioAvaliacaoRotinaCliente } from '../../comum/modelos/criterio-avaliacao-rotina-cliente';
import { CriticidadeRotina } from '../../comum/modelos/criticidade-rotina';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';
import { Evento } from '../../comum/eventos/evento';

@Component({
  selector: 'app-cadastro-rotina',
  templateUrl: './cadastro-rotina.component.html',
  styleUrls: ['./cadastro-rotina.component.css']
})
export class CadastroRotinaComponent implements OnInit {

  rotina: RotinaCliente;
  criticidadesRotina: CriticidadeRotina[];
  criteriosAvaliacao: CriterioAvaliacao[];

  MODO: string;
  CADASTRAR = 'Cadastrar';
  ATUALIZAR = 'Atualizar';
  public statusCode: number;
  public loading = false;

  evento: Evento;

  public quantidadeCriterios = 0;

  constructor(private _rotinaService: RotinaService,
    private _comumService: ComumService,
    private _activatedRoute: ActivatedRoute,
    private _cookieService: CookieService,
    public _authService: AuthService) {
    this.rotina = new RotinaCliente();
    this.criticidadesRotina = new Array<CriticidadeRotina>();
    this.criteriosAvaliacao = new Array<CriterioAvaliacao>();

    this.evento = this._comumService.evento;

    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 3000);
    }
  }

  ngOnInit() {
    this.loading = true;
    const self = this;
    const criticidade = self._rotinaService.obterCriticidadesRotinaHttp();
    const idRotina = self._activatedRoute.snapshot.params['id'];
    const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
    this.quantidadeCriterios = 4;
    if (idRotina !== undefined) {
      const rid = self._rotinaService.obterRotinaClientePorIdHttp(idRotina);
      forkJoin(criticidade, rid)
        .subscribe(([criticidadesRotina, rotina]) => {
          self.criticidadesRotina = criticidadesRotina;
          rotina.idCliente = idCliente;
          self.rotina = rotina;
          self.MODO = self.ATUALIZAR;
          self.quantidadeCriterios = rotina.criteriosAvaliacaoRotina.length;
          self.loading = false;
        });
    } else {
      const criterios = self._rotinaService.obterCriteriosAvaliacaoHttp();
      forkJoin(criticidade, criterios)
        .subscribe(([criticidadesRotina, criteriosAvaliacaoRotina]) => {
          self.quantidadeCriterios = 2;
          self.criticidadesRotina = criticidadesRotina;
          for (const criterio of criteriosAvaliacaoRotina) {
            if (criterio.nomeCriterioAvaliacao === 'Sim' || criterio.nomeCriterioAvaliacao === 'N\u00e3o') {
              const criterioAvaliacaoRotina = new CriterioAvaliacaoRotinaCliente();
              criterioAvaliacaoRotina.CriterioAvaliacao = criterio;
              self.rotina.insertCriterioAvaliacaoRotina = criterioAvaliacaoRotina;
            }
          }
          self.rotina.idCliente = idCliente;
          self.MODO = self.CADASTRAR;
          self.loading = false;
        });
    }
  }

  radioValueCheck(x: number) {
    this.quantidadeCriterios = x;
    this._rotinaService.obterCriteriosAvaliacaoHttp().subscribe(criterios => {
      this.rotina.criteriosAvaliacaoRotina = new Array();
      for (const criterio of criterios) {
        if (this.quantidadeCriterios === 2) {
          if (criterio.nomeCriterioAvaliacao === 'Sim' || criterio.nomeCriterioAvaliacao === 'N\u00e3o') {
            const criterioAvaliacaoRotina = new CriterioAvaliacaoRotinaCliente();
            criterioAvaliacaoRotina.CriterioAvaliacao = criterio;
            this.rotina.insertCriterioAvaliacaoRotina = criterioAvaliacaoRotina;
          }
        } else if (this.quantidadeCriterios === 3) {
          if (criterio.nomeCriterioAvaliacao === 'Sim' || criterio.nomeCriterioAvaliacao === 'N\u00e3o'
            || criterio.nomeCriterioAvaliacao === 'Parcial') {
            const criterioAvaliacaoRotina = new CriterioAvaliacaoRotinaCliente();
            criterioAvaliacaoRotina.CriterioAvaliacao = criterio;
            this.rotina.insertCriterioAvaliacaoRotina = criterioAvaliacaoRotina;
          }
        } else {
          if (criterio.nomeCriterioAvaliacao !== 'Sim' && criterio.nomeCriterioAvaliacao !== 'N\u00e3o'
            && criterio.nomeCriterioAvaliacao !== 'Parcial') {
            const criterioAvaliacaoRotina = new CriterioAvaliacaoRotinaCliente();
            criterioAvaliacaoRotina.CriterioAvaliacao = criterio;
            this.rotina.insertCriterioAvaliacaoRotina = criterioAvaliacaoRotina;
          }
        }
      }
    });
  }

  onSubmit(): void {

    const self = this;

    if (self.MODO === self.CADASTRAR) {
      self._rotinaService.cadastrarRotinaClienteHttp(self.rotina)
        .subscribe(response => {
          self.loading = false;
          self.statusCode = response.status;
          self._comumService.evento.cadastro = true;
        }, errorCode => {
          self.statusCode = errorCode;
          self.loading = false;
        });
    } else {
      self._rotinaService.atualizarRotinaClienteHttp(self.rotina)
        .subscribe(response => {
          self.loading = false;
          self.statusCode = response.status;
          self._comumService.evento.cadastro = true;
        }, errorCode => {
          self.statusCode = errorCode;
          self.loading = false;
        });
    }

  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/cadastro-rotina/cadastro-rotina.component.ts